import { KEY } from "./key";

export default {
  headers: {
    // origin: 'http://localhost:3000',//dùng để lấy slide
    // origin: 'http://webroyal.ttithutech.com',//dùng để lấy slide
    origin: 'https://en.royal.edu.vn',//dùng để lấy slide
    // origin: 'https://beta.royal.edu.vn',//dùng để lấy slide
    'app-key': process.env.NODE_ENV === 'production' ? KEY.APP_ID : KEY.APP_ID_TEST
  }
}
